/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacetGroupModel
 */
export interface FacetGroupModel {
    /**
     * 
     * @type {string}
     * @memberof FacetGroupModel
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof FacetGroupModel
     */
    readonly name?: string;
    /**
     * 
     * @type {number}
     * @memberof FacetGroupModel
     */
    readonly sortOrder?: number;
}

/**
 * Check if a given object implements the FacetGroupModel interface.
 */
export function instanceOfFacetGroupModel(value: object): boolean {
    return true;
}

export function FacetGroupModelFromJSON(json: any): FacetGroupModel {
    return FacetGroupModelFromJSONTyped(json, false);
}

export function FacetGroupModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacetGroupModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function FacetGroupModelToJSON(value?: Omit<FacetGroupModel, 'id'|'name'|'sortOrder'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
    };
}

